<template>
  <div>
    <form-section>
      <el-row>
        <el-col class="date-time-ct">
          <form-item
            prop="end_date"
            :label="$t('CampaignForm_Schedule_Salesforce_Date')"
            class="date-input input"
          >
            <el-date-picker
              format="MMMM d, yyyy"
              value-format="yyyy-MM-dd"
              v-model="model.end_date"
              :placeholder="
                $t('CampaignForm_Schedule_Salesforce_Placeholder_ManualStop')
              "
            />
          </form-item>
          <form-item
            prop="end_date_time"
            :label="$t('CampaignForm_Schedule_Salesforce_Time')"
            class="time-input input"
          >
            <el-time-picker
              format="HH:mm"
              value-format="HH:mm"
              v-model="model.end_date_time"
              :placeholder="
                $t('CampaignForm_Schedule_Salesforce_Placeholder_StopTime')
              "
            />
          </form-item>
          <form-item
            prop="timezone"
            :label="$t('CampaignForm_Schedule_Salesforce_Timezone')"
            class="timezone-select"
          >
            <el-select v-model="model.timezone" filterable clearable>
              <el-option
                v-for="(label, value) in timezones"
                :key="value"
                :value="value"
                :label="label"
              >
                <span v-tooltip>{{ label }}</span>
              </el-option>
            </el-select>
          </form-item>
        </el-col>
      </el-row>
    </form-section>
    <offline-users-component
      v-if="model.ios_push || model.android_push || model.web_push"
      :model="model"
    />
    <persist-content-component v-if="model.inbox" :model="model" />
  </div>
</template>

<script>
import FormSection from '@/common/components/form/FormSection'
import FormItem from '@/common/components/form/FormItem'
import OfflineUsersComponent from '@/modules/campaign-manage/components/schedule/OfflineUsersComponent'
import PersistContentComponent from '@/modules/campaign-manage/components/schedule/PersistContentComponent'
import { mapGetters } from 'vuex'
export default {
  name: 'ScheduleSelectorSalesforce',
  components: {
    PersistContentComponent,
    OfflineUsersComponent,
    FormItem,
    FormSection
  },
  props: {
    model: {
      type: Object
    }
  },
  computed: {
    ...mapGetters(['timezones'])
  }
}
</script>

<style scoped lang="scss">
>>> .el-radio {
  height: unset !important;
  min-height: 80px !important;
  max-height: 120px !important;
  white-space: unset;
}

>>> .title {
  font-weight: 600;
  line-height: 22px;
  color: #5c6374;
}
.date-time-ct {
  display: flex;
}

.date-input {
  width: 200px;
}

.time-input {
  width: 121px;
}

.timezone-select {
  width: 375px;
}
.input {
  margin-right: 16px;
}
/deep/ .el-form-item__label {
  color: #5c6374;
  font-size: 14px;
  line-height: 22px;
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/modules/campaign-manage/components/schedule/ScheduleSelectorSalesforce.vue